import { isDefined } from "@clipboard-health/util-ts";
import { Box, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";

import { type WorkerVisitLockMessageProps } from "../type";
import { parseAgentChatMessage } from "../utils";
import { UnlockRequestButton } from "./UnlockRequestButton";

function isMessageFromCurrentLock(messageCreatedAt: number, lockedAt: string): boolean {
  return messageCreatedAt >= new Date(lockedAt).getTime();
}

export function WorkerVisitLockMessage(props: WorkerVisitLockMessageProps) {
  const { message, lockedAt } = props;

  if (!isDefined(message)) {
    return null;
  }

  const messageText = parseAgentChatMessage(message);

  if (!isDefined(messageText)) {
    return null;
  }

  const showUnlockRequestButton =
    isDefined(lockedAt) && isMessageFromCurrentLock(message.createdAt, lockedAt);

  return (
    <Box
      sx={(theme) => ({
        padding: theme.spacing(5),
        marginBottom: theme.spacing(2),
        background: theme.palette.secondary.main,
        borderRadius: theme.borderRadius?.leftChatMessage,
      })}
    >
      <Stack spacing={4}>
        <Text variant="body1" color="text.primary" sx={{ whiteSpace: "pre-line" }}>
          {messageText}
        </Text>
        {showUnlockRequestButton && <UnlockRequestButton />}
      </Stack>
    </Box>
  );
}
